import { useContext } from 'react';
import { UserMediaContext, type UserMediaContextProps } from './context';

export const useUserMedia = (): UserMediaContextProps => {
  const context = useContext(UserMediaContext);
  if (!context) {
    throw new Error('useUserMedia must be used within an UserMediaProvider');
  }
  return context;
};
